
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { logger } from "@/lib/logger";

export function usePaymentStatus(onPaymentSuccess: () => void) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { toast } = useToast();

  useEffect(() => {
    const success = searchParams.get('success');
    const canceled = searchParams.get('canceled');
    const sessionId = searchParams.get('session_id');
    
    if (success === 'true' && sessionId) {
      logger.info({
        message: "Payment success detected",
        context: { sessionId }
      });
      
      toast({
        title: "Payment Successful!",
        description: "Your subscription has been activated.",
      });
      
      // Call the success callback
      onPaymentSuccess();
      
      // Clean up the URL after processing
      setSearchParams({});
    } else if (canceled === 'true') {
      logger.warn({
        message: "Payment cancellation detected",
        context: { timestamp: new Date().toISOString() }
      });
      
      toast({
        title: "Payment Canceled",
        description: "You can try again when you're ready.",
        variant: "destructive",
      });
      
      // Clean up the URL after processing
      setSearchParams({});
    }
  }, [searchParams, toast, onPaymentSuccess, setSearchParams]);
}
